<template>
  <div class ref="rail">
    <!-- EVENT RAIL HEADER -->

    <SectionHeader
      :see-all-path="seeAllPath"
      class="mx-1"
      style="margin-bottom: 4px"
      :title="sectionHeaderTitle"
      :title-lg="titleLg"
      :title-Md="titleMd"
      :has-border-top="titleHasBorderTop"
    ></SectionHeader>

    <div
      v-if="isCardLoading"
      style="min-height: 140px; width: 100%; overflow:hidden; position: relative"
    >
      <b-loading animation :is-full-page="false" :active.sync="isCardLoading" :can-cancel="false"></b-loading>
    </div>

    <!-- <div style="display: grid; grid-template-columns: 1fr"> -->
    <!-- <div class="grid-gap"></div> -->
    <div class="event-list" :style="{'grid-template-columns': isSingleCol ? '1fr' : '94% 98%'}">
      <div
        itemscope
        itemtype="http://schema.org/Event"
        class="event-card no-highlight"
        :class="{'card-has-border-bottom': isSingleCol ? ind < eventLimit-1 : ind < (eventLimit - 2 )}"
        v-for="(event, ind) in events"
        :key="event.id"
      >
        <div class="grid-gap"></div>
        <!-- IMAGE -->
        <div class="event-card--img">
          <router-link
            @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name: event.data.eventName, item_id: event.id, button_name: 'event_img_on_card_rail'})"
            :to="{name: 'event-view', params: {eventID: event.id, eventPreview: event}}"
          >
            <!-- @click.native="$store.commit('appData/SET_DISPLAYED_EVENT', event)" -->
            <figure class="image">
              <img
                itemprop="image"
                v-if="event.data.eventImagePaths.posterURLs"
                class="is-lazy"
                lazy="loaded"
                v-lazy="event.data.eventImagePaths.posterURLs[0]"
                :alt="event.data.eventName"
              />
            </figure>
          </router-link>
        </div>

        <div class="event-card--content">
          <div style="margin-top: -3px;" >
            <!-- EVENT TYPES -->
            <div
              class="has-ellipsis"
              style="margin-top: -2px; margin-bottom: 4px;line-height: 1"
              v-if="showType"
            >
              <router-link
                @click.native="$analytics.logEvent('view_item_list', { page_name: $route.name, item_name: event.data.eventMainType, button_name: 'main_type_on_card_rail'})"
                :to="{name: 'events', params: {cityName: $store.state.user.userCity, slug: event.data.eventMainType }}"
                class="is-size-13px cursor-link has-text-link"
              >{{ $t(`evType.${event.data.eventMainType}`) | capitalize }}</router-link>
              <!-- <span
                class="is-size-xs subtitle has-text-grey-dark"
              >&nbsp;>&nbsp;</span>-->
              <span
                v-if="event.data.eventSubTypes.length"
                class="icon is-small has-text-grey-light"
                style="transform: translateY(2.5px);  margin-left: -2px;margin-right:-2px"
              >
                <i class="mdi mdi-chevron-right mdi-16px"></i>
              </span>
              <router-link
                @click.native="$analytics.logEvent('view_item_list', { page_name: $route.name, item_name: event.data.eventMainType, button_name: 'subtype_on_card_rail'})"
                :to="{ name: 'events', params: {cityName: $store.state.user.userCity,slug: event.data.eventMainType }, query: { subtype: event.data.eventSubTypes.join(',')}}"
                class="is-size-7 cursor-link has-text-link subtitle has-ellipsis"
              >{{ eventSubtypesJoined(event.data.eventSubTypes) }}</router-link>
            </div>


            <!-- EVENT NAME -->
            <router-link
              class="no-highlight is-inline-block"
              :to="{name: 'event-view', params: {eventID: event.id, eventPreview: event}}"
              @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name: event.data.eventName, item_id: event.id, button_name: 'event_title_on_card_rail'})"
            >
              <h4
                itemprop="name"
                style="line-height: 1.25; padding-bottom: 2px; padding-top: 1px"
                class="has-text-black cursor-link has-text-weight-medium is-size-6"
              >{{ $options.filters.truncate(event.data.eventName, (windowViewWidth / 4)) }}</h4>
            </router-link>


            <!-- EVENT DATETIME -->
            <CardDatetime
            class="is-size-14px "
              :show-type="showType"
              :event-showtimes="event.data.eventShowtimes"
              :only-date="showTime"
            ></CardDatetime>

            <!-- EVENT Venue -->
            <CardVenue
              style="margin-top: 0px; margin-bottom: 1px; display: block;"
              class="is-size-14px"
              :show-venue-logo="false"
              :show-venue="showVenue"
              :event-venue-name="event.data.eventVenueName"
              :event-venue-id="event.data.eventVenueID"
              :event-venue-avatar-url="event.data.eventVenueAvatarURL"
              :event-venue-rich-address="event.data.eventVenueRichAddress"
            ></CardVenue>

            <CardPrice
              style="font-size: 15px"
              :event-ticket-info="event.data.eventTicketInfo"
              :event-id="event.id"
            ></CardPrice>
          </div>
        </div>

        <div
          style="display:flex; justify-content: space-between; flex-wrap: wrap; height: 100%;flex-wrap: wrap; flex-flow: column;"
        >
          <StarBtn :event="event"></StarBtn>

          <router-link
            @click.native="$analytics.logEvent('view_item', { page_name: $route.name, item_name:event.data.eventName, button_name: 'chevron_on_category_card'})"
            :to="{ name: 'event-view', params: { eventID: event.id, eventPreview: event }}"
            class="card-row cursor-link no-highlight"
            style="margin-top: 2px"
          >
            <span
              class="icon has-background-white-ter is-rounded is-medium"
              style="margin-bottom: 3px"
            >
              <i class="mdi mdi-chevron-right mdi-24px"></i>
            </span>
          </router-link>
        </div>
        <div class="grid-gap"></div>

        <!-- ./EVENT CARD CONTENT -->
      </div>
      <!-- <hr class="p-0" style="margin-left: 88px; "> -->
    </div>
  </div>
</template>

<script>
// import { ticketPriceMixin } from "@/mixins/ticket";
import CardDatetime from "@/components/shared/CardDatetime";
import SectionHeader from "@/components/shared/SectionHeader";
import CardVenue from "@/components/shared/CardVenue";
import CardPrice from "@/components/shared/CardPrice";
import StarBtn from "@/components/shared/StarBtn";

export default {
  props: {
    passedEvents: {
      type: Array,
      // required: true,
      default: () => []
    },
    routeName: {
      type: String,
      default: ""
    },
    eventType: {
      type: String,
      default: ""
    },
    eventSubtypes: {
      type: Array,
      // default: ""
      default: () => []
    },
    venueId: {
      type: String,
      default: ""
    },
    eventId: {
      type: String,
      default: ""
    },
    orderLimit: {
      type: Number,
      default: 6
    },
    railHeader: {
      type: String
    },
    seeAllPath: {
      type: String,
      default: ""
    },
    showType: {
      type: Boolean,
      default: false
    },
    showTime: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: ""
    },
    showPrice: {
      type: Boolean,
      default: false
    },
    showVenue: {
      type: Boolean,
      default: true
    },
    showSubType: {
      type: Boolean,
      default: false
    },
    titleMd: {
      type: Boolean,
      default: false
    },
    titleLg: {
      type: Boolean,
      default: false
    },
    eventLimit: {
      type: Number,
      default: 4
    },
    sectionHeaderTitle: {
      type: String,
      default: ""
    },
    titleHasBorderTop: {
      type: Boolean,
      default: true
    },
    isSingleCol: {
      type: Boolean,
      default: false
    }
    // cardIsMedium: {
  },
  components: { CardDatetime, CardPrice, SectionHeader, CardVenue, StarBtn },
  data() {
    return {
      events: [],
      isCardLoading: false,
      windowViewWidth: 320
    };
  },

  created() {
    if (process.env.NODE_ENV === "development") {
      // console.log("TypeCard created", this.passedEvents, "events", this.events);
    }
    // if (this.routeName !== this.$route.name) return;

    this.windowViewWidth = window.innerWidth;

    if (this.passedEvents && this.passedEvents.length) {
      this.events = this.passedEvents;
      return;
    }

    this.isCardLoading = true;

    this.fetchEvents();
  },
  methods: {
    async fetchEvents() {
      if (process.env.NODE_ENV === "development") {
        // console.log("there is evnet type", this.eventType);
      }

      if (this.venueId) {
        try {
          this.events = await this.$store.dispatch(
            "appData/fetchEventsByVenueID",
            {
              venueID: this.venueId,
              orderLimit: this.orderLimit
            }
          );
          const eventCount =
            this.events.filter(e => e.id !== this.eventId).length > 0;
          // console.log("event count", eventCount);

          this.$emit("event-count", eventCount);
          // this.events = events.filter(e => e.id !== this.eventId);
        } catch (error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
        }
      } else if (this.eventType.length) {
        try {
          this.events = await this.$store.dispatch(
            "appData/fetchEventsByType",
            {
              eventType: this.eventType,
              orderLimit: this.orderLimit,
              eventSubtypes: this.eventSubtypes
            }
          );
        } catch (error) {
          if (process.env.NODE_ENV === "development") {
            console.error(error);
          }
        }
      }

      if (this.eventId.length) {
        this.events = this.events
          .filter(e => e.id !== this.eventId)
          .slice(0, this.eventLimit);
      }

      // if no events remove rail
      if (!this.events.length) {
        this.$refs.rail.style.display = "none";
      } else {
        this.$emit("is-loaded", true);
      }

      this.isCardLoading = false;
    },
    eventSubtypesJoined(subtypes) {
      let joined = "";
      for (let i = 0; i < subtypes.length; i++) {
        joined += this.$options.filters.capitalize(
          this.$t(`evType.${subtypes[i]}`)
        );
        if (i !== subtypes.length - 1) joined += ", ";
      }
      return joined;
    },
    logHitCategoryMenuItem(val) {
      this.$analytics.logEvent("view_item_list", {
        item_name: val,
        page_name: this.$route.name
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.event-header {
  padding: 0 1rem;
  margin-bottom: 8px;
  display: flex;
  flex-flow: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
}

.event-header .title {
  margin-bottom: 0 !important;
}

.event-list {
  width: 100%;
  display: grid;
  padding-left: 12px;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  -webkit-scroll-snap-type: mandatory;
  -webkit-scroll-snap-destination: 50% 50%;
}

$event-card-poster-width: 64px;
.event-card {
  -webkit-scroll-snap-coordinate: 50% 50%;
  scroll-snap-align: center;
  display: inline-grid;
  // grid:
  grid-template-columns: 2px $event-card-poster-width auto 36px 6px;
  padding-top: 12px;
  padding-bottom: 8px;
}

// .event-card + .event-card {
// }

.event-card--img {
  .image {
    width: $event-card-poster-width;
    min-height: $event-card-poster-width;
    // height: 100%;
    border-radius: 2px;
    overflow: hidden;
    -webkit-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
    -moz-box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
    box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px;
    img {
      // width: $event-card-poster-width !important;
      min-height: $event-card-poster-width;
      object-fit: cover;
    }
  }
}
.event-card--content {
  // padding-bottom: 6px;
  display: flex;
  min-width: 90%;
  line-height: 1.45;
  margin-left: 12px;
  // margin-right: 8px;
}

.card-has-border-bottom {
  // border-bottom: 1px solid $grey-lighter;
}
</style>